var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691 976q-78.435 0-133.718-55.282Q502 865.435 502 787q0-78.435 55.282-133.718Q612.565 598 691 598q78.435 0 133.718 55.282Q880 708.565 880 787q0 78.435-55.282 133.718Q769.435 976 691 976Zm58.243-88L777 860l-75-75V673h-39v126l86.243 89ZM180 922q-24.75 0-42.375-17.625T120 862V280q0-24.75 15.5-42.375T162 220h202q7-35 34.5-57.5T462 140q36 0 63.5 22.5T560 220h202q24.75 0 42.375 17.625T822 280v295q-15-9-29.516-15.48Q777.968 553.04 762 548V280H656v130H286V280H180v582h273q5 15 12 29.5t17 30.5H180Zm300-646q17 0 28.5-11.5T520 236q0-17-11.5-28.5T480 196q-17 0-28.5 11.5T440 236q0 17 11.5 28.5T480 276Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingActions);
export default __webpack_public_path__ + "static/media/pending_actions.7c77d37fc452497bccf8020dada7ba57.svg";
export { ForwardRef as ReactComponent };